import { Page } from '../components';
import { ParcelRateForm } from '../forms';

export const ParcelRate = () => <Page render={() => <ParcelRateForm />} />;
